import { render } from "./RecommendationRejected.vue?vue&type=template&id=3b3d2856&scoped=true"
import script from "./RecommendationRejected.vue?vue&type=script&lang=js"
export * from "./RecommendationRejected.vue?vue&type=script&lang=js"

import "./RecommendationRejected.vue?vue&type=style&index=0&id=3b3d2856&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3d2856"]])

export default __exports__